import ClientDocumentsPanel from './ClientDocumentsPanel';

export default ClientDocumentsPanel;
